import { safeDefine } from "../../registration/safe-define.js";
import { CompatVideoSkinElement } from "../../presets/video/compat-skin.js";
import "../../internal/skins/compat-video/register.js";
//#region src/define/video/compat-skin.ts
safeDefine(CompatVideoSkinElement);
//#endregion
